module.exports = __webpack_public_path__ + "media/banker_win.9070d791.mp3";